import { PropsWithChildren, ReactNode } from 'react'

import * as S from "./styled"

const Wrapper = ({ children }: PropsWithChildren<ReactNode>) => (
  <S.Wrapper data-testid="chat-modal" className="chat-modal">
    {children}
  </S.Wrapper>
)

export default Wrapper
